import { FormattedMessage } from 'react-intl';
import QRCode from 'react-qr-code';

import { KioskNavigationHeader } from '../../components/kiosk-navigation-header.component';
import { useKioskNavigate } from '../../utils/kiosk-navigation';

const ID = 'read-eula';

const EULA_URL = 'https://drive.google.com/file/d/1Gpt4N6kvRmvNlRDc6Q3LVMsBRdl5SrYj/view';

const ReadEula = () => {
    const navigate = useKioskNavigate();

    return (
        <div
            className='bg-background-default flex size-full flex-col items-center justify-start overflow-hidden'
            id={ID}>
            <KioskNavigationHeader
                title={
                    <FormattedMessage
                        defaultMessage='Read EULA'
                        description='Button text for reading the End User License Agreement (EULA) in the general info modal.'
                        id='generalInfoModal.readEula'
                    />
                }
                onBack={() => navigate(-1)}
            />
            <div className='flex size-full flex-col items-start justify-start gap-3 overflow-y-auto px-6 py-4'>
                <div className='flex flex-col items-start justify-start gap-3 self-stretch'>
                    <div className='text-foreground-default w-96 justify-end text-base font-medium'>
                        <FormattedMessage
                            defaultMessage='Scan the QR code below to view the End User License Agreement (EULA) document.'
                            description='Instruction text for reading the End User License Agreement (EULA) in the general info modal.'
                            id='generalInfoModal.readEulaDescription'
                        />
                    </div>
                    <div className='flex flex-col items-start justify-start gap-2 self-stretch'>
                        <div className='bg-background-surface border-border-default flex flex-col items-center justify-center gap-3 self-stretch rounded-xl border p-8'>
                            <QRCode value={EULA_URL} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReadEula;
